export default __webpack_public_path__ + "static/broadcastImg1-c3ab61937c581fcb0e314addd8b7709a.webp";